// extracted by mini-css-extract-plugin
module.exports = {"dialog":"_2R8Tq","description":"_2MjfT","input":"COgUe"};